import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { useToastSeeker } from "@ui-seeker/app"
import { deleteSubmit, getSubmit, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, SERVICES_TYPE } from "@constants"
import { isLoadingUserSettingAcrissData, userSettingAcrissData, userSettingAcrissFormData, isEditUserSettingsAcrissDrawer } from "../@signals"


export default function useUserSettingsAcriss(rowData={}) {
	const { showToast } = useToastSeeker()
	const isLoading = useSignal(false)

	const getAcrissData = useCallback(() => {
		getSubmit(`${BACKEND_APIS.CRUD}/user/acriss_color`)
			.then(data => userSettingAcrissData.value = data)
			.catch(() => {
				showToast.error()
				userSettingAcrissData.value = []
			}).finally(() => isLoadingUserSettingAcrissData.value = false)
	}, [])

	const handleSetAcrissFormData = useCallback(() => userSettingAcrissFormData.value = {
		id: rowData.id || null,
		color: rowData.color,
		acriss_code: rowData.acriss_code || null,
		service_type: SERVICES_TYPE.ACRISS_COLOR
	}, [JSON.stringify(rowData)])

	const handleChangeAcrissFormData = useCallback((newValue, prop) => userSettingAcrissFormData.value = {
		...userSettingAcrissFormData.value,
		[prop]: newValue
	}, [])

	const handleSubmitAcrissFormData = useCallback(() => {
		isLoading.value = true
		postSubmit(`${BACKEND_APIS.CRUD}/${!isEditUserSettingsAcrissDrawer.value ? 'add' : 'update'}`, userSettingAcrissFormData.value).then(res => {
			if (isEditUserSettingsAcrissDrawer.value) {
				userSettingAcrissData.value = [
					...userSettingAcrissData.value.map(item => item.id === userSettingAcrissFormData.value.id ? res : item)
				]
			} else {
				userSettingAcrissData.value = [
					...userSettingAcrissData.value,
					res
				]
			}
			userSettingAcrissFormData.value = {}
		}).catch(() => showToast.error())
			.finally(() => isLoading.value = false)
	}, [])

	const handleDeleteAcriss = useCallback(() => showToast.confirm(`Are you sure you want to delete this row? This action cannot be undone.`, {
		onSubmit: () => {
			isLoading.value = true
			deleteSubmit(`${BACKEND_APIS.CRUD}/delete/${SERVICES_TYPE.ACRISS_COLOR}?id=${rowData.id}`).then(() => {
				userSettingAcrissData.value = [
					...userSettingAcrissData.value.filter(item => item.id !== rowData.id)
				]
			}).catch(() => showToast.error())
				.finally(() => isLoading.value = false)
		}
	}), [JSON.stringify(rowData)])

	return {
		isClicked: rowData.id === userSettingAcrissFormData.value.id,
		isLoading: isLoading.value,
		getAcrissData,
		handleSetAcrissFormData,
		handleChangeAcrissFormData,
		handleSubmitAcrissFormData,
		handleDeleteAcriss
	}
}